module.exports = __webpack_public_path__ + "images/08-04@2x_b6c04657.png";